<template>
    <div>
        <div style="z-index: 4; position: absolute; top: 0; bottom: 0; left: 0; right: 0;" @click.stop="tag_dropdown_open = false, system_dropdown_open = false, type_dropdown_open = false" v-if="tag_dropdown_open || system_dropdown_open || type_dropdown_open">
        </div>
        <div class="loading-spinner-outer" v-if="loading">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Loading
                </div>
            </div>
        </div>
        <div class="loading-spinner-outer" v-if="saving_file">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Uploading file, please wait
                </div>
            </div>
        </div>
        <div class="box" v-if="!loading">
            <div class="box-content">
                <div class="flex-2xs">
                    <div class="half-width-2xs pr-3-2xs">
                        <div class="tabs-container _nav-top">
                            <div class="tab-content" :class="{ 'active' : upload_mode === 'file' }" v-if="upload_mode === 'file'">
                                <div class="tab-content-inner">
                                    <div class="form-group mb-0 flex flex-col">
                                        <label>Upload File</label>
                                        <form :action="`${$aws_upload_url}`" method="post"
                                              enctype="multipart/form-data" id="amazon_form">
                                            <input type="hidden" name="policy" :value="aws_policy">
                                            <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                                            <input type="hidden" name="x-amz-credential" :value="aws_credential">
                                            <input type="hidden" name="x-amz-date" :value="aws_date">
                                            <input type="hidden" name="x-amz-signature" :value="aws_signature">
                                            <input type="hidden" name="acl" value="private">
                                            <input type="hidden" name="Content-Type" v-model="filetype">
                                            <input type="hidden" name="key" v-model="content_upload.filename">
                                        </form>
                                        <vue-dropzone
                                                ref="fileUploadDropzone"
                                                id="dropzone"
                                                :options="dropzoneOptions"
                                                v-on:vdropzone-file-added="fileAddedToDropZone"
                                                v-on:vdropzone-removed-file="fileRemovedFromDropZone"
                                                :useCustomSlot="true"
                                        >
                                            <div>
                                                <div class="mb-3">
                                                    DRAG AND DROP FILE
                                                </div>
                                                <div class="mb-3">
                                                    OR
                                                </div>
                                                <div>
                                                    <a class="btn-secondary-outline">
                                                        Choose a file
                                                    </a>
                                                </div>
                                            </div>
                                        </vue-dropzone>
                                    </div>
                                    <div class="txt-sm">
                                        <p>
                                            <em>
                                                Images and PDFs will generate a thumbnail automatically. If you are uploading a different type of file (or would like to override the automatic thumbnail) upload a thumbnail image here.
                                            </em>
                                        </p>
                                    </div>
                                    <div class="form-group mb-0-2xs flex flex-col">
                                        <label>Upload Thumbnail</label>
                                        <form :action="`${$aws_upload_url}`" method="post"
                                              enctype="multipart/form-data" id="thumbnail_amazon_form">
                                            <input type="hidden" name="policy" :value="aws_policy">
                                            <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                                            <input type="hidden" name="x-amz-credential" :value="aws_credential">
                                            <input type="hidden" name="x-amz-date" :value="aws_date">
                                            <input type="hidden" name="x-amz-signature" :value="aws_signature">
                                            <input type="hidden" name="acl" value="private">
                                            <input type="hidden" name="Content-Type" v-model="thumbnail_upload.filetype">
                                            <input type="hidden" name="key" v-model="thumbnail_upload.filename">
                                        </form>
                                        <vue-dropzone
                                                ref="thumbnailFileUploadDropzone"
                                                id="thumbnail_dropzone"
                                                :options="dropzoneOptions"
                                                v-on:vdropzone-file-added="thumbnailFileAddedToDropZone"
                                                v-on:vdropzone-removed-file="thumbnailFileRemovedFromDropZone"
                                                :useCustomSlot="true"
                                        >
                                            <div>
                                                <div class="mb-3">
                                                    DRAG AND DROP FILE
                                                </div>
                                                <div class="mb-3">
                                                    OR
                                                </div>
                                                <div>
                                                    <a class="btn-secondary-outline">
                                                        Choose a file
                                                    </a>
                                                </div>
                                            </div>
                                        </vue-dropzone>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="half-width-2xs pl-3-2xs">
                        <div class="form-group">
                            <label>Name</label>
                            <input type="text" v-model="content_upload.name" class="form-control">
                        </div>
                        <div class="form-group hide">
                            <label>Sort Order</label>
                            <input type="hidden" v-model="content_upload.sort_order" class="form-control">
                        </div>
                        <div class="form-group">
                            <label>Upload Type</label>
                            <div class="multi-select-input">
                                <div class="multi-select-input-placeholder" @click="type_dropdown_open = !type_dropdown_open">
                                    <template v-if="selected_content_upload_type">
                                        {{ selected_content_upload_type.name }}
                                    </template>
                                    <template v-else>
                                        Select Type ...
                                    </template>
                                    <div class="dropdown-icon">
                                        <i class="fal fa-chevron-down"></i>
                                    </div>
                                </div>
                                <div class="multi-select-input-inner" v-show="type_dropdown_open" @click="type_dropdown_open = false">
                                    <div class="multi-select-input-group">
                                        <div class="radios">
                                            <div class="radio level-1" v-for="content_upload_type in content_upload_types">
                                                <label>
                                                    <input type="radio" name="content_upload_type" :value="content_upload_type.id" v-model="content_upload.content_upload_type_id">
                                                    <span class="radio-label">{{ content_upload_type.name }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Systems</label>
                            <div class="multi-select-input">
                                <div class="multi-select-input-placeholder" @click="system_dropdown_open = !system_dropdown_open">
                                    <template v-if="selected_system_types.length > 0">
                                        <span v-for="type in selected_system_types">{{ type.label }}, </span>
                                    </template>
                                    <template v-else>
                                        Select Systems ...
                                    </template>
                                    <div class="dropdown-icon">
                                        <i class="fal fa-chevron-down"></i>
                                    </div>
                                </div>
                                <div class="multi-select-input-inner" v-show="system_dropdown_open">
                                    <div class="multi-select-input-group">
                                        <div class="checkboxes">
                                            <div class="checkbox level-1" v-for="system_type in system_types">
                                                <label>
                                                    <input type="checkbox" name="epwin_system_types" :value="system_type.id" v-model="content_upload.epwin_system_type_ids">
                                                    <span class="checkbox-label">{{ system_type.label }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Tags</label>
                            <div class="multi-select-input">
                                <div class="multi-select-input-placeholder" @click="tag_dropdown_open = !tag_dropdown_open">
                                    <template v-if="selected_tags.length > 0">
                                        <span v-for="tag in selected_tags">{{ tag.name }}, </span>
                                    </template>
                                    <template v-else>
                                        Select Tags ...
                                    </template>
                                    <div class="dropdown-icon">
                                        <i class="fal fa-chevron-down"></i>
                                    </div>
                                </div>
                                <div class="multi-select-input-inner" v-show="tag_dropdown_open">
                                    <div class="multi-select-input-group">
                                        <div class="checkboxes">
                                            <div class="checkbox level-1" v-for="tag in tags">
                                                <label>
                                                    <input type="checkbox" name="tags" :value="tag.id" v-model="content_upload.tags">
                                                    <span class="checkbox-label">{{ tag.name }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      <div class="form-group">
                        <label>Send Notification</label>
                        <div class="radios _inline">
                          <label class="radio">
                            <input type="radio" v-model="send_notification" :value="true">
                            <span class="radio-label">Yes</span>
                          </label>
                          <label class="radio">
                            <input type="radio" v-model="send_notification" :value="false">
                            <span class="radio-label">No</span>
                          </label>
                        </div>
                      </div>
                      <div class="form-group" v-if="send_notification && selected_content_upload_type !== undefined">
                        <label>Send Notification To</label>
                        <div class="checkboxes">
                          <label class="checkbox">
                            <input type="checkbox" v-model="send_notification_to" :value="1" :disabled="!selected_content_upload_type.available_for_company_types.includes(1)">
                            <span class="checkbox-label">Fabricators</span>
                          </label>
                          <div class="txt-danger txt-sm" v-if="!selected_content_upload_type.available_for_company_types.includes(1)">
                            Selected upload type not available for Fabricators
                          </div>
                          <label class="checkbox">
                            <input type="checkbox" v-model="send_notification_to" :value="2" :disabled="!selected_content_upload_type.available_for_company_types.includes(2)">
                            <span class="checkbox-label">Installers</span>
                          </label>
                          <div class="txt-danger txt-sm" v-if="!selected_content_upload_type.available_for_company_types.includes(2)">
                            Selected upload type not available for Installers
                          </div>
                            <label class="checkbox">
                                <input type="checkbox" v-model="send_notification_to" :value="3" :disabled="!selected_content_upload_type.available_for_company_types.includes(3)">
                                <span class="checkbox-label">Trade Counter</span>
                            </label>
                            <div class="txt-danger txt-sm" v-if="!selected_content_upload_type.available_for_company_types.includes(3)">
                                Selected upload type not available for Trade Counters
                            </div>
                            <label class="checkbox">
                                <input type="checkbox" v-model="send_notification_to" :value="5" :disabled="!selected_content_upload_type.available_for_company_types.includes(5)">
                                <span class="checkbox-label">Builders</span>
                            </label>
                            <div class="txt-danger txt-sm" v-if="!selected_content_upload_type.available_for_company_types.includes(5)">
                                Selected upload type not available for Builders
                            </div>
                            <label class="checkbox">
                              <input type="checkbox" v-model="send_notification_to" :value="6" :disabled="!selected_content_upload_type.available_for_company_types.includes(6)">
                              <span class="checkbox-label">Trial Companies</span>
                            </label>
                            <div class="txt-danger txt-sm" v-if="!selected_content_upload_type.available_for_company_types.includes(6)">
                              Selected upload type not available for Trial Companies
                            </div>
                            <label class="checkbox">
                                <input type="checkbox" v-model="send_notification_to" :value="4" :disabled="!selected_content_upload_type.available_for_company_types.includes(4)">
                                <span class="checkbox-label">Other</span>
                            </label>
                            <div class="txt-danger txt-sm" v-if="!selected_content_upload_type.available_for_company_types.includes(4)">
                                Selected upload type not available for Other Companies
                            </div>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="align-right">
                    <a class="btn-primary" @click.prevent="save()">
                        Save
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

  import vue2Dropzone from 'vue2-dropzone';

  export default {
    props: [
      'aws_policy',
      'aws_credential',
      'aws_date',
      'aws_signature',
    ],
    components: {
      'vue-dropzone': vue2Dropzone,
    },
    data() {
      return {
        send_notification_to: [1,2,3,4,5],
        system_types: [],
        content_upload_types: [],
        tags: [],
        content_upload: {
          tags: [],
          epwin_system_type_ids: [],
        },
        loading: true,
        filename: '',
        filetype: '',
        saving_file: false,
        uploaded_file: null,
        dropzoneOptions: {
          url: '/',
          autoProcessQueue: false,
          uploadMultiple: true,
          addRemoveLinks: true,
        },
        tag_dropdown_open: false,
        system_dropdown_open: false,
        type_dropdown_open: false,
        send_notification: true,
        upload_mode: 'file',
        thumbnail_upload_uploaded_file: null,
        thumbnail_upload: {
          filetype: '',
          filename: '',
          thumbnail_url: '',
        },
      };
    },
    computed: {
      selected_content_upload_type() {
        return this.content_upload_types.filter((type) => type.id === this.content_upload.content_upload_type_id)[0];
      },
      selected_system_types() {
        return this.system_types.filter((type) => this.content_upload.epwin_system_type_ids.includes(type.id));
      },
      selected_tags() {
        return this.tags.filter((tag) => this.content_upload.tags.includes(tag.id));
      },
    },
    async mounted() {
      await this.loadTags();
      await this.loadSystemTypes();
      await this.loadContentUploadTypes();
      const vueThis = this;
      vueThis.$nextTick().then(function () {
        vueThis.update_who_can_get_notifications();
      });
      this.loading = false;
    },
    methods: {
      fileAddedToDropZone(uploadedFile) {
        const extension = uploadedFile.name.replace(/^.*\./, '');
        const original_file_name = uploadedFile.name.replace('.'+extension, '');

        if (this.content_upload.name !== '') {
          this.content_upload.name = original_file_name;
        }

        const allowed_extensions = [
          'jpg', 'jpeg', 'png',  'svg', 'gif', 'bmp', 'tif', 'pdf', 'zip', 'xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx', 'mp4',
        ];

        if(!allowed_extensions.includes(extension.toLowerCase())) {
          this.$refs.fileUploadDropzone.dropzone.removeAllFiles();
          Swal.fire({
            title: 'Invalid File Type',
            icon: 'error',
            text: 'File type not allowed, please ensure the file is one of the following formats: jpg, png, svg, gif, bmp, tif, pdf, xls, doc, ppt, mp4',
          });
          return;
        }

        if (this.$refs.fileUploadDropzone.dropzone.files.length > 1) {
          this.$refs.fileUploadDropzone.dropzone.removeFile(this.$refs.fileUploadDropzone.dropzone.files[0]);
        }

        const filename = 'content_uploads/'+ original_file_name + '_' + Date.now();
        this.content_upload.filename = filename + '.' + extension;

        if(extension.toLowerCase() === 'svg') {
          this.content_upload.thumbnail_url = this.content_upload.filename;
        } else {
          this.content_upload.thumbnail_url = 'thumbnails/' + filename + '.png';
        }

        if(extension.toLowerCase() === 'mp4') {
          this.content_upload.type = 'video';
        } else {
          this.content_upload.type = 'file';
        }

        this.filetype = uploadedFile.type;
        this.uploaded_file = uploadedFile;
      },
      fileRemovedFromDropZone(file) {
        this.filetype = null;
        this.uploaded_file = null;
        this.content_upload.filename = null;
        this.content_upload.thumbnail_url = null;
      },
      thumbnailFileAddedToDropZone(uploadedFile) {
        const extension = uploadedFile.name.replace(/^.*\./, '');
        const original_file_name = uploadedFile.name.replace('.'+extension, '');

        const allowed_extensions = [
          'jpg', 'jpeg', 'png',  'svg', 'gif', 'bmp',
        ];

        if(!allowed_extensions.includes(extension.toLowerCase())) {
          this.$refs.thumbnailFileUploadDropzone.dropzone.removeAllFiles();
          Swal.fire({
            title: 'Invalid File Type',
            icon: 'error',
            text: 'File type not allowed, please ensure the file is one of the following formats: jpg, png, svg, gif, bmp',
          });
          return;
        }

        if (this.$refs.thumbnailFileUploadDropzone.dropzone.files.length > 1) {
          this.$refs.thumbnailFileUploadDropzone.dropzone.removeFile(this.$refs.thumbnailFileUploadDropzone.dropzone.files[0]);
        }

        const filename = 'content_uploads/uploaded_thumbs/'+ original_file_name + '_' + Date.now();
        this.thumbnail_upload.filename = filename + '.' + extension;

        if(extension.toLowerCase() === 'svg') {
          this.thumbnail_upload.thumbnail_url = this.thumbnail_upload.filename;
        } else {
          this.thumbnail_upload.thumbnail_url = 'thumbnails/' + filename + '.png';
        }

        this.thumbnail_upload.filetype = uploadedFile.type;
        this.thumbnail_upload_uploaded_file = uploadedFile;
      },
      thumbnailFileRemovedFromDropZone(file) {
        this.thumbnail_upload_uploaded_file = null;
        this.thumbnail_upload.filetype = null;
        this.thumbnail_upload.filename = null;
        this.thumbnail_upload.thumbnail_url = null;
      },
      async loadTags() {
        await axios.get('/downloads/getTags').then((response) => {
          this.tags = response.data;
        });
      },
      async loadSystemTypes() {
        await axios.get('/downloads/getSystemTypes').then((response) => {
          this.system_types = response.data;
        });
      },
      async loadContentUploadTypes() {
        await axios.get('/downloads/getContentUploadTypes').then((response) => {
          this.content_upload_types = response.data;
        });
      },
      save() {
        const validationErrors = Validate({
          name: this.content_upload.name,
          type: this.content_upload.content_upload_type_id,
          tags: this.content_upload.tags,
          file: this.uploaded_file,
          systems: this.content_upload.epwin_system_type_ids,
        }, {
          name: {
            presence: {
              allowEmpty: false,
            },
          },
          type: {
            presence: {
              allowEmpty: false,
              message: 'must be chosen'
            },
          },
          tags: {
            presence: {
              allowEmpty: false,
              message: 'must be chosen'
            },
          },
          systems: {
            presence: {
              allowEmpty: false,
              message: 'must be chosen'
            },
          },
          file: {
            presence: {
              allowEmpty: false,
              message: 'must be uploaded'
            },
          },
        });

        if (validationErrors) {
          Swal.fire({
            title: 'Unable to save file',
            icon: 'error',
            html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
          });
          return;
        }

        this.saving_file = true;

        let form_data = new FormData(document.querySelector('#amazon_form'));
        form_data.append('file', this.uploaded_file);

        axios({
          method: 'post',
          url: this.$aws_upload_url,
          data: form_data,
          headers: {'Content-Type': 'multipart/form-data'}
        }).then(() => {

          if(this.thumbnail_upload_uploaded_file !== null) {
            let thumbnail_form_data = new FormData(document.querySelector('#thumbnail_amazon_form'));
            thumbnail_form_data.append('file', this.thumbnail_upload_uploaded_file);
            axios({
              method: 'post',
              url: this.$aws_upload_url,
              data: thumbnail_form_data,
              headers: {'Content-Type': 'multipart/form-data'}
            }).then(() => {
              // if there's a custom thumbnail, replace the autogenerated thumbnail_url on the content_upload
              this.content_upload.thumbnail_url = this.thumbnail_upload.thumbnail_url;
              this.saveContentUpload();
            });
          } else {
            this.saveContentUpload();
          }

        });

      },
      saveContentUpload() {
        axios.post('/downloads/create', {
          content_upload: this.content_upload,
          send_notification: this.send_notification,
          send_notification_to: this.send_notification_to,
        }).then((response) => {
          window.location.href = '/downloads';
        });
      },
      update_who_can_get_notifications() {
        if(this.selected_content_upload_type !== undefined) {
          const company_types = [1, 2, 3, 4, 5];
          company_types.forEach(type => {
            if (!this.selected_content_upload_type.available_for_company_types.includes(type)) {
              const indexToRemove = this.send_notification_to.indexOf(type);
              if (indexToRemove !== -1) {
                this.send_notification_to.splice(indexToRemove, 1);
              }
            }
          });
        }
      },
    },
    watch: {
      tag_dropdown_open() {
        if (this.tag_dropdown_open) {
          this.system_dropdown_open = false;
          this.type_dropdown_open = false;
        }
      },
      system_dropdown_open() {
        if (this.system_dropdown_open) {
          this.tag_dropdown_open = false;
          this.type_dropdown_open = false;
        }
      },
      type_dropdown_open() {
        if (this.type_dropdown_open) {
          this.tag_dropdown_open = false;
          this.system_dropdown_open = false;
        }
      },
      selected_content_upload_type() {
        this.send_notification_to = [1,2,3,4,5];
        this.update_who_can_get_notifications();
      }
    },
  };
</script>
